import classNames from 'classnames';
import { ComponentPropsWithoutRef, forwardRef } from 'react';
import { MdSearch } from 'react-icons/md';
import styles from './SearchInput.module.scss';

export type SearchInputProps = ComponentPropsWithoutRef<'input'>;

const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(({ className, ...props }, ref) => {
  return (
    <div className={classNames(styles.wrapper, className)}>
      <MdSearch size={18} />
      <input {...props} ref={ref} />
    </div>
  );
});

SearchInput.displayName = 'SearchInput';

export { SearchInput };
